// extracted by mini-css-extract-plugin
export default {"navbar":"styles_navbar__5v2wB","navbarNav":"styles_navbarNav__cA0Lu","navItem":"styles_navItem__WzVQO","navLink":"styles_navLink__jxVfo","linkText":"styles_linkText__kx5Q1"};